/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from "react";
import {useQuery} from "@apollo/react-hooks";
import Chart from "react-google-charts";
import {SizeMe} from "react-sizeme";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import {GET_CONTACT_ACCOUNT_POSITIONS} from "../../database/queries/contactAccountPositionQueries";

const INITIAL_CHART_DATA = [
    [
        {type: 'string', id: 'Organization'},
        {type: 'string', id: 'Title'},
        {type: 'date', id: 'Start'},
        {type: 'date', id: 'End'},
    ],
];

const PopupContactAccountPositionChart = props => {
    const [chartData, setChartData] = useState();
    const [searchStr] = useState();
    const [globalLayoutState] = useLayoutStore();

    const {
        loading: getContactAccountPositionsLoading,
        error: getContactAccountPositionsError,
        data: getContactAccountPositionsData,
        refetch: getContactAccountPositionsRefetch
    } = useQuery(GET_CONTACT_ACCOUNT_POSITIONS, {
        skip: !props.editId,
        variables: {
            contactId: props.editId,
            searchStr: searchStr,
            // limit: 10,
            // offset: 0,
            orderList: ['endDate DESC', 'startDate DESC']
        },
    });

    useEffect(() => {
        if (getContactAccountPositionsError) notify('getContactAccountPositionsError', 'error', getContactAccountPositionsError.message);
    }, [getContactAccountPositionsError]);

    useEffect(() => {
        if (getContactAccountPositionsData && getContactAccountPositionsData.contactAccountPositions) {
            let tempChartData = [...INITIAL_CHART_DATA];
            for (let p = 0; p < getContactAccountPositionsData.contactAccountPositions.length; p++) {
                const position = getContactAccountPositionsData.contactAccountPositions[p];
                const a = [
                    position.account.accountName,
                    position.title,
                    new Date(position.startDate),
                    position.current ? new Date() : new Date(position.endDate)
                ];
                console.log('getContactAccountPositionsData', a);
                tempChartData.push(a);
            }
            setChartData(tempChartData);
        }
    }, [getContactAccountPositionsData]);

    useEffect(() => {
        getContactAccountPositionsRefetch();
    }, [searchStr]);

    if (getContactAccountPositionsLoading) return <p>Loading ...</p>;
    if (getContactAccountPositionsError) return `Error! ${getContactAccountPositionsError.message}`;

    return (
        <div>
            {getContactAccountPositionsData.contactAccountPositions && (
                <div>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;
                            const boxHeight = height - (globalLayoutState.tabBarHeight + 80);

                            return (
                                <Chart
                                    width={size.width}
                                    height={boxHeight}
                                    chartType="Timeline"
                                    loader={<div>Loading Chart</div>}
                                    data={chartData}
                                    rootProps={{'data-testid': '2'}}
                                />
                            )
                        }}
                    </SizeMe>
                </div>
            )}
        </div>
    );
};

export default PopupContactAccountPositionChart
